import type { Resolution, TimePeriod } from '@carboncopyco/types';
import {
  DropdownFilter,
  type DropdownFilterItemContent,
} from '@carboncopyco/ui';

export interface AnalyticsPageActivityFilterBarProps {
  setResolution: (selected: Resolution) => void;
  resolution: Resolution;
  resolutionOptions: DropdownFilterItemContent<Resolution>[];
  setTimePeriod?: (period: TimePeriod) => void;
  timePeriod?: TimePeriod;
  timePeriodOptions?: DropdownFilterItemContent<TimePeriod>[];
}

export const defaultTimePeriodOptions: DropdownFilterItemContent<TimePeriod>[] =
  [
    {
      label: 'Last 7 days',
      id: '7',
    },
    {
      label: 'Last 30 days',
      id: '30',
    },
    {
      label: 'Last 60 days',
      id: '60',
    },
    { label: 'Last 90 days', id: '90' },
  ];

export const ActivityChartFilterBar = ({
  setResolution,
  resolution,
  resolutionOptions,
  setTimePeriod,
  timePeriod,
  timePeriodOptions,
}: AnalyticsPageActivityFilterBarProps) => {
  const showTimePeriodFilter = setTimePeriod && timePeriod;

  return (
    <div className="flex items-center gap-3">
      {showTimePeriodFilter && (
        <DropdownFilter
          rounded={false}
          capsuleWidth={140}
          contentWidth={140}
          items={timePeriodOptions ?? defaultTimePeriodOptions}
          onSelect={setTimePeriod}
          selected={timePeriod}
          placeholder={timePeriod}
        />
      )}
      <DropdownFilter
        rounded={false}
        capsuleWidth={116}
        contentWidth={116}
        items={resolutionOptions}
        onSelect={setResolution}
        selected={resolution}
        placeholder={resolution}
      />
    </div>
  );
};
